
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Only redirect once the auth state is confirmed (not loading)
    if (!isLoading) {
      if (!user) {
        // If no user is found after loading completes, redirect to auth page
        navigate('/auth');
      } else {
        // Auth check is complete and user is authenticated
        setAuthChecked(true);
      }
    }
  }, [user, isLoading, navigate]);

  // Show loading state while authentication status is being checked
  if (isLoading || !authChecked) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <div className="text-white">
          <div className="h-8 w-8 border-t-2 border-[#9E7C47] rounded-full animate-spin mx-auto mb-4"></div>
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  // Only render children when user is authenticated and auth check is complete
  return <>{children}</>;
};

export default ProtectedRoute;
